// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isAppsEngagementReportsCampaignsByTagsResult = arrayOf(
  objectOf({
    campaign_name: string,
    id: string,
    messaging_actions: arrayOf(
      objectOf({
        message_type: string,
      })
    ),
    created: objectOf({
      time: number,
    }),
    campaign_type: string,
    is_archived: boolean,
  })
);
